export default __webpack_public_path__ + "static/media/icon-spaces.3852e844.svg";